export default [
  {
    path: '/app/estates',
    name: 'Estates',
    component: () => import('@/views/Admin/Estates/Index.vue'),
    meta: {
      pageTitle: 'Mülkler',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_ESTATES',
      action: 'read',
    },
  },
  {
    path: '/app/estates/add',
    name: 'EstateAdd',
    component: () => import('@/views/Admin/Estates/Add.vue'),
    meta: {
      pageTitle: 'Mülkler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/estates',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_ESTATES',
      action: 'read',
    },
  },
  {
    path: '/app/estates/edit/:id',
    name: 'EstateEdit',
    component: () => import('@/views/Admin/Estates/Edit.vue'),
    meta: {
      pageTitle: 'Mülkler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/estates',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_ESTATES',
      action: 'read',
    },
  },
]
